<template>
    <div>
        <div class="J-galery-upload-container">
            <div class="J-galery-upload-file"  title="Hague click para subir su foto">
                <div v-if="!imageUrl" class="J-galery-upload-file-action" @click="upload()" >
                    
                </div>
                <i  v-if="!imageUrl" class="fas fa-camera"></i>
                <img class="J-galery-upload-img" v-if="imageUrl" :src="imageUrl" data-toggle="tooltip">
                <button @click="action()" v-if="imageUrl" class="J-galery-upload-button"><i  class="fas fa-save"></i></button>
            </div>
        </div>
        <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @change="onFilePicked"
        > 
    </div>
</template>
<script>
    export default {
        data(){
            return{
                imageUrl: '',
                imageFile: '',
                imageName: ""
            }
        
        },
        methods:{
            action:function(){
                this.$emit("action",this.imageUrl)
            },
            upload:function(){
                this.pickFile();
            },
            pickFile () {
                this.$refs.image.click()
            },
            onFilePicked (e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.imageName = files[0].name
                    if(this.imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    
                    if (!(/\.(jpg|png|gif|jpeg)$/i).test(this.imageName))
                    {
                        alert('Comprueba la extensión de tus imagenes, recuerda que los formatos aceptados son .gif, .jpeg, .jpg y .png');
                        this.imageName = ''
                        this.imageUrl = '/'+this.userstorage.photo
                    }else{
                        const fr = new FileReader ()
                        fr.readAsDataURL(files[0])
                        fr.addEventListener('load', () => {
                            this.imageUrl = fr.result
                            this.imageFile = files[0] // this is an image file that can be sent to server...
                            this.imageName = files[0].name
                            //console.log(this.imageUrl)
                        })
                    }
                } else {
                    this.imageName = ''
                    this.imageFile = ''
                }
            },
        }
    }
</script>